<template>
  <div class="solution">
    <div class="banner">
      <img src="@/assets/images/solution.jpg">
    </div>
    <div class="wrap">
      <div class="problem">
        <h3>您的业务开展是否有以下问题？</h3>
        <div class="problem-box">
           <div class="problem-item">
              <div class="pic"><img src="../assets/images/problem1.png"></div>
              <div class="text"><p>刚开始做，不清楚客户画像在哪、市场如何选择</p></div>
           </div>
           <div class="problem-item">
              <div class="pic"><img src="../assets/images/problem2.png"></div>
              <div class="text"><p>渠道与服务种类太多，方案千篇一律，但无法匹配实际业务特征</p></div>
           </div>
           <div class="problem-item">
              <div class="pic"><img src="../assets/images/problem3.png"></div>
              <div class="text"><p>推广策略与执行效果难衡量，需要适合当前阶段的外贸业务拓展最佳实践</p></div>
           </div>
           <div class="problem-item">
              <div class="pic"><img src="../assets/images/problem4.png"></div>
              <div class="text"><p>想要提升内部团队数字营销专业能力，但无从下手</p></div>
           </div>
        </div>
      </div>
    </div>

    <div class="distance">
      <div class="wrap">
        <h3>数字营销解决方案的实施流程</h3>
        <div class="distance-box">
          <div class="item">
            <div class="pic">
              <img src="../assets/images/step1.png" class="title-img" />
              <img src="../assets/images/icon3.png" class="title-icon" />
            </div>
            <div class="txt">
              <p>行业客户洞察</p>
              <span>企业品牌和产品分析<br>目标用户和市场分析<br>竞争对手分析<br>营销趋势分析<br>营销预算<br>组织分析</span>
            </div>
          </div>
          <div class="item">
            <div class="pic">
              <img src="../assets/images/step2.png" class="title-img" />
              <img src="../assets/images/icon6.png" class="title-icon" />
            </div>
            <div class="txt">
              <p>解决方案设计</p>
              <span>关键词选择<br>投放渠道选择<br>独立站设计<br>落地页设计<br>内容创意<br>预算分配</span>
            </div>
          </div>
          <div class="item">
            <div class="pic">
              <img src="../assets/images/step3.png" class="title-img" />
              <img src="../assets/images/icon4.png" class="title-icon" />
            </div>
            <div class="txt">
              <p>解决方案交付</p>
              <span>进行广告投放<br>独立站/落地页优化<br>用户培育&跟踪<br>成交签约</span>
            </div>
          </div>
          <div class="item">
            <div class="pic">
              <img src="../assets/images/step4.png" class="title-img" />
              <img src="../assets/images/icon5.png" class="title-icon" />
            </div>
            <div class="txt">
              <p>营销ROI</p>
              <span>对营销各环节指标进行监测<br>持续优化，提升营销效果</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="product">
      <div class="wrap">
        <h3>提供围绕客户全生命周期的产品与服务</h3>
        <div class="product-box">
          <div class="left">
            <h3>产品</h3>
            <div class="pic-box">
               <div class="line">
                  <div class="img-box">
                    <img src="../assets/images/icon7.png"/>
                    <div class="text">
                      <p>全渠道营销介质管理</p>
                      <span>互联网数字营销平台</span>
                    </div>
                  </div>
               </div>
            </div>
          </div>
          <div class="right">
            <h3>服务</h3>
            <div class="right-box">
              <div class="pic-box boder-pic">
                <div class="line">
                    <div class="img-box">
                      <img src="../assets/images/icon8.png"/>
                      <div class="text">
                        <p>流量获取</p>
                        <span>数字营销广告投放</span>
                      </div>
                    </div>
                </div>
              </div>
              <div class="pic-box">
                <div class="line">
                    <div class="img-box">
                      <img src="../assets/images/icon9.png"/>
                      <div class="text">
                        <p>转化提升</p>
                        <span>品效合一介质建设与运营</span>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="customer">
      <div class="wrap">
        <div class="title">
          <h1>全方位专业高效服务支持</h1>
          <p>全国主要城市的上门面对面沟通，完成方案设计、上门解决服务过程中的问题</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: { },
  name: 'SolutonModule',  // 组件名称
};
</script>

<style scoped>
.problem{
  padding: 80px 0;
}
.problem h3{
  font-size: 24px;
  text-align: center;
}
.problem-box{
  display: flex;
  gap: 140px;
  padding-top: 80px;
}
.problem-item{
  text-align: center;
  margin: auto;
}
.problem-item .pic{
  width: 180px;
  height: 160px;
  overflow: hidden;
  margin: auto;
}
.problem-item .pic img{
  display: block;
  width: 100%;
  height: 100%;
}
.problem-item .text{
  width: 200px;
  height: 90px;
  margin: 20px 0;
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
  display: -ms-flexbox; /* TWEENER - IE 10 */
  display: -webkit-flex; /* NEW - Chrome */
  display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
  flex-direction: column; /* 使子元素垂直排列 */
  overflow: hidden; /* 隐藏溢出的内容 */
}
.problem-item .text p{
  display: block; /* 使子元素块级显示，以便可以应用overflow属性 */
  overflow: hidden; /* 隐藏溢出的内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
  -webkit-line-clamp: 3; /* 限制显示的行数为2 */
  -webkit-box-orient: vertical; /* 使文本垂直排列 */
  font-size: 16px;
}

.distance{
  width: 100%;
  position: relative;
  background-image: url(../assets//images/bj2.jpg);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  padding: 80px 0;
}

.distance .wrap>h3{
  font-size: 24px;
  color: #fff;
  text-align: center;
}
.distance-box{
  display: flex;
  gap: 40px;
  margin: 60px 0 20px 0;
  justify-content: center;
}
.distance-box .item{
  background: #f6f6f6;
  border-radius: 10px;
  padding: 30px;
  width: 25%;
}
.distance-box .item .pic{
  display: flex;
  flex-direction: column;
}
.title-img{
  display: block;
  width: 125px;
  height: auto;
}
.title-icon{
  display: block;
  width: 70px;
  height: 65px;
  margin: 25px 0;
}
.distance-box .item .txt p{
  font-size: 18px;
  color: #1639a2;
}
.distance-box .item .txt span{
  width: 260px;
  font-size: 14px;
  color: #111111;
  margin-top: 10px;
  line-height: 25px;
}

.distance-box .item .txt{
  width: 100%;
  /* height: 120px; */
}
.product{
  padding: 60px 0;
}
.product .wrap>h3{
  text-align: center;
  font-size: 24px;
  color: #111111;
}
.product-box{
  display: flex;
  gap: 55px;
  justify-content: center;
}
.product-box .left h3{
  font-size: 24px;
  text-align: center;
  color: #1639a2;
  margin: 30px 0;
}
.product-box .right h3{
  font-size: 24px;
  color: #1639a2;
  margin: 15px 0;
}
.product-box .left .pic-box{
  width: 300px;
  height: 300px;
  border-radius: 50%;
  border: 1px solid #5ebaa4;
  padding: 10px;
  position: relative;
}
.product-box .left .pic-box .line{
  border: 1px #5ebaa4 dashed;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  padding: 10px;
}
.product-box .left .pic-box .line .img-box{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}
.product-box .left .pic-box .line .img-box img{
  display: block;
  width: 100%;
}

.product-box .left .pic-box .line .img-box .text{
  width: 100%;
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
}
.product-box .left .pic-box .line .img-box .text p{
  font-size: 20px;
  padding: 0 60px;
  color: #fff;
  height: 60px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制行数为3 */
  overflow: hidden;
}
.product-box .left .pic-box .line .img-box .text span{
  display: inline-block;
  background: #1bbb9f;
  border-radius: 20px;
  padding: 5px 10px;
  font-size: 14px;
  color: #fff;
  margin: 10px 0;
}
.product-box .left .pic-box::before{
  content: '';
  width: 86px;
  height: 69px;
  display: block;
  background-image: url(../assets//images/icon2.png);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  position: absolute;
  right: -64px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.boder-pic::before{
  content: '';
  width: 86px;
  height: 69px;
  display: block;
  background-image: url(../assets//images/icon2.png);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  position: absolute;
  right: -64px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.product-box .right .right-box {
  display: flex;
  gap: 55px;
  border: 1px #5ebaa4 solid;
  border-radius: 150px;
}
.product-box .right>h3{
  text-align: center;
  margin: 30px 0;
}
.product-box .right .pic-box{
  width: 300px;
  height: 300px;
  border-radius: 50%;
  padding: 10px;
  position: relative;
}

.product-box .right .pic-box .line{
  border: 1px #5ebaa4 dashed;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  padding: 10px;
}
.product-box .right .pic-box .line .img-box{
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
}
.product-box .right .pic-box .line .img-box img{
  display: block;
  width: 100%;
}

.product-box .right .pic-box .line .img-box .text{
  width: 100%;
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  text-align: center;
}
.product-box .right .pic-box .line .img-box .text p{
  font-size: 20px;
  padding: 0 60px;
  color: #fff;
  height: 60px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制行数为3 */
  overflow: hidden;
}
.product-box .right .pic-box .line .img-box .text span{
  display: inline-block;
  background: #1cb4d4;
  border-radius: 20px;
  padding: 5px 10px;
  font-size: 14px;
  color: #fff;
  margin: 10px 0;
}

.customer{
    width: 100%;
    position: relative;
    /* height: 480px; */
    background-image: url(../assets//images/bj.jpg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    padding: 150px 0;
  }
  .customer .title{
    text-align: center;
    color: #fff;
  }
  .customer .title h1{
    font-size: 36px;
    margin-bottom: 20px;
  }
  .customer .title p{
    font-size: 18px;
  }
.banner{
  width: 100%;
}
.banner img{
  display: block;
  width: 100%;
}
</style>
